import React from "react";
const Hanger = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27.976"
      height="24.039"
      viewBox="0 0 27.976 24.039"
      style={style}
    >
      <g id="Hanger" transform="translate(-2.023 -1.961)">
        <path
          id="Tracciato_336"
          data-name="Tracciato 336"
          d="M29.66,24.25,17,13.23V11.86A5,5,0,1,0,11,7a1,1,0,1,0,2,0,3,3,0,1,1,3,3,1,1,0,0,0-1,1v2.27l-12.66,11A1,1,0,0,0,3,26H29a1,1,0,0,0,.66-1.75ZM5.67,24,16,15l10.33,9Z"
          fill="#232323"
        />
      </g>
    </svg>
  );
};

export default Hanger;
